import { addUnits } from "./utils/addUnits";

const _setHeight = (el: HTMLElement, height: string | number) => {
  if (!el){
    return
  }
  el.style.height = addUnits(height);
}
export function setHeight (els: string | HTMLElement | NodeListOf<HTMLElement>, value: string | number) {
  if (typeof els === 'string') {
    els = document.querySelectorAll(els);
    els.forEach(it => {
      _setHeight(it, value)
    })
  } else if (els instanceof NodeList) {
    els.forEach(it => {
      _setHeight(it, value)
    })
  } else {
    _setHeight(els, value)
  }

}